import React from 'react';

import Icon from '@mui/material/Icon';
import colorsVars from 'styles/colors.module.scss';

const { iconColor } = colorsVars;

export interface Props extends React.HTMLAttributes<HTMLSpanElement> {
    icon?: string;
    fontSize?: string;
    color?: string;
    type?: 'outlined' | 'round' | 'sharp';
}

export const MuiIcon = ({ icon, fontSize = '2rem', color = iconColor, type, ...rest }: Props) => {
    const baseClassName = type ? `material-icons-${type}` : 'material-icons';

    return icon ? (
        <Icon sx={{ fontSize, color }} baseClassName={baseClassName} {...rest} data-testid={'material-icon'}>
            {icon}
        </Icon>
    ) : null;
};
